<template>
  <modal-wrap
    :id="id"
    ref="IntegrationsShopifySettings"
    :name="modalName"
    :header-class="'integrations-shopify-settings-header'"
    body-class="integrations-shopify-settings-modal"
    :hide-footer="true"
    size="md"
  >
    <template #modal-title>
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="mb-0">Shopify Settings</h4>
      </div>
    </template>
    <template #default>
      <b-form-group>
        <div class="row">
          <div class="form-group">
            <label><b>Shop:</b></label>
            <input
              v-model="externalId"
              class="form-control"
              autocomplete="off"
              name="shop"
              placeholder="Shop domain (e.g. myshopify.com)"
            />
          </div>
        </div>
        <div class="row">
          <div class="form-group">
            <div class="form-check mb-0 mt-0">
              <input id="sendLabels" v-model="updateLabel" class="form-check-input" type="checkbox" />
              <label for="sendLabels" class="form-check-label"> Send Label to Shopify </label>
            </div>
          </div>
        </div>
        <div class="form-group">
          <button type="button" class="btn create-btn btn-green" @click="connect">Connect</button>
        </div>
      </b-form-group>
    </template>
  </modal-wrap>
</template>

<script lang="ts">
import type { ShopifyIntegrationModal } from '@/types/Models/Integration'
import { BFormGroup } from 'bootstrap-vue-next'
import { defineComponent, ref, computed, type ComputedRef, type Ref, watch } from 'vue'
import { SHOPIFY_WEBHOOK_SETTINGS } from '@/const/ModalTypes'
import { catchErrors } from '@/services/Helpers'
import { useCustomersIntegrationsStore } from '@/store/customers/integrations'
import { useVueNextModalStore } from '@/store/vueNextModal'
import ModalWrap from '@/views/Modals/ModalWrap.vue'

export default defineComponent({
  name: 'IntegrationsShopifySettingsModal',
  components: { BFormGroup, ModalWrap },
  props: {
    id: { type: String, required: true },
  },
  setup() {
    const modalStore = useVueNextModalStore()
    const customersIntegrationsStore = useCustomersIntegrationsStore()

    const modalName = SHOPIFY_WEBHOOK_SETTINGS
    const updateLabel: Ref<boolean> = ref(true)
    const externalId: Ref<string> = ref('')
    const modalData: ComputedRef<ShopifyIntegrationModal | null> = computed(
      () => modalStore.modalPropsByName(modalName) || null,
    )

    const connect = () => {
      if (!modalData.value || !externalId.value) return
      customersIntegrationsStore
        .connectShopify({
          customerId: modalData.value.customerId,
          updateLabel: updateLabel.value,
          externalId: externalId.value,
        })
        .then(() => {
          window.open('https://apps.shopify.com/pacsortonline', '_self')
          modalStore.closeModal(modalName)
        })
        .catch(catchErrors)
    }

    watch(
      () => modalData.value,
      (newData) => {
        if (newData) {
          externalId.value = newData.externalId || ''
        }
      },
      { immediate: true },
    )

    return {
      connect,
      externalId,
      updateLabel,
      modalData,
      modalName,
    }
  },
})
</script>
